import { ActionBar, AddIcon, Button, Dialog, Modal, SpinnerWithBackground, TagField, Text } from '@viapeople/components'
import { useState } from 'react'
import { AddReviewersModal } from '../../../../components/PopulationFields/AddReviewersModal'
import { pluralize } from '../../../../utils/formatters'
import { useCycleReviewersList } from './hooks/useCycleReviewersList'

export const CycleReviewersListEditReviewers = () => {
	const {
		cycle,
		reviewersGroups,
		reviewersByGroups,
		headerData,
		handleRemoveReviewer,
		handleAddReviewer,
		handleSaveChanges,
		handleNavigateBack,
		getExcludedUserIds,
		errorByGroup,
		isLoading,
		confirmDialogState,
		handleConfirmDialogClose,
	} = useCycleReviewersList()
	const [addingReviewersGroup, setAddingReviewersGroup] = useState<string>()

	const content = (
		<>
			<div className='flex gap-x-10 m-6 border-b border-neutral-100 pb-6'>
				{headerData.map((item) => (
					<div key={item.label}>
						<Text variant='xsmall'>{item.label}</Text>
						<Text variant='medium' weight='semibold'>
							{item.value}
						</Text>
					</div>
				))}
			</div>

			{reviewersGroups?.data.map((group) => {
				const reviewers = reviewersByGroups.find((r) => r.groupId === group.id)?.reviewers
				const error = errorByGroup[group.id]
				const hint = `${group.minReviewers > 0 ? `Min: ${group.minReviewers} ${pluralize(group.minReviewers, 'reviewer', 'reviewers')}. ` : ''} ${group.maxReviewers > 0 ? `Max: ${group.maxReviewers} ${pluralize(group.maxReviewers, 'reviewer', 'reviewers')}. ` : ''}`
				return (
					<div className='flex px-6 pb-6' key={group.id}>
						<TagField
							label={`${group.name} (${reviewers?.length || 0})`}
							placeholder=''
							className='min-h-13'
							value={reviewers?.map((reviewer) => ({
								id: reviewer.externalId,
								label: reviewer.name,
							}))}
							variant={error ? 'error' : 'default'}
							hint={
								<>
									{error && (
										<Text variant='hint' weight='regular' className='text-error-600 inline'>
											{error}
										</Text>
									)}
									<Text variant='hint' weight='regular' className='inline text-neutral-600'>
										{hint}
									</Text>
								</>
							}
							onChange={(value) => handleRemoveReviewer(value, group.id)}
						/>
						<Button
							variant='secondary'
							icon={AddIcon}
							iconPosition='right'
							className='ml-2 mt-7'
							onClick={() => setAddingReviewersGroup(group.id)}>
							Add
						</Button>
					</div>
				)
			})}
		</>
	)

	return (
		<Modal isOpen fullContent fullScreen onClose={handleNavigateBack} title='Participant'>
			{isLoading ? <SpinnerWithBackground /> : content}
			<AddReviewersModal
				isOpen={!!addingReviewersGroup}
				onClose={() => setAddingReviewersGroup(undefined)}
				organizationId={cycle?.organizationId}
				excludedUserExternalIds={() => getExcludedUserIds(addingReviewersGroup as string)}
				onSelect={(users) => handleAddReviewer(users, addingReviewersGroup as string)}
			/>
			<Dialog
				isOpen={confirmDialogState.isOpen}
				onClose={handleConfirmDialogClose}
				title='Confirm Changes'
				message={confirmDialogState.message}
				onConfirm={() => {
					if (confirmDialogState.onConfirm) {
						confirmDialogState.onConfirm()
					}
				}}
				confirmLabel='Continue'
				type='confirm'
			/>
			<ActionBar
				variant='modal'
				className='left-0'
				rightActions={[
					{
						label: 'Cancel',
						onClick: handleNavigateBack,
					},
					{
						label: 'Save Changes',
						variant: 'primary',
						onClick: handleSaveChanges,
					},
				]}
			/>
		</Modal>
	)
}
